import React, { useState } from 'react'
import AddNewGoals from './AddNewGoals';

const Goals = ({ data, setIsRecordSaved, expandAll, ...props }) => {
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenGoals, setIsOpenGoals] = useState(false);
  const [goalID, setGoalID] = useState();
  const [showInActiveProblems, setShowInActiveProblems] = useState(false);

  let Active = ['active', 'Active'];
  let InActive = ['in active', 'In Active'];
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddGoals = (ID) => {
    if(!isViewAllowed) return;
    setGoalID(ID)
    setIsOpenGoals(prev => !prev);
  }
  const CloseGoals = () => {
    setIsOpenGoals(false)
  }

  let PopupScreen = "";
  if (isOpenGoals) {
    PopupScreen = <AddNewGoals isOpenGoals={isOpenGoals} goalID={goalID} onClose={CloseGoals} setIsRecordSaved={setIsRecordSaved} setGoalID={setGoalID} patientID={props?.patientID} // onDeleteGoals={DeleteGoals}
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed} 
    />
  }
  const ShowHideInActive = () => {
    let inActiveCount = data.filter(item => (InActive.includes(item.GoalStatus))).length;
    return inActiveCount > 0 ? <p className='heading validate-color cursor-pointer px-2 pt-2' onClick={() => setShowInActiveProblems(prev => !prev)}>
      {showInActiveProblems ? `Hide InActive(${inActiveCount})` : `Show InActive(${inActiveCount})`}
    </p> : null
  }
  return (
    <>
      {PopupScreen}
      <div className='content-box px-0'>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
          <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Goals</p>
          <i className={`icon-dash-plus fs-19 ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddGoals(null)}></i>
        </div>
        <div className="">
          {expandItems &&
            expandAll &&
            (data?.length > 0 ?
              <>
                <div className='d-flex flex-column gap-1 problem-scroll px-2'>
                  {data.map(item => {

                    let inActive = !(Active.includes(item.GoalStatus));
                    if ((inActive && !showInActiveProblems)) return;
                    return (
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <div className='ar-dot'>
                          <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddGoals(item.PAtientGoalID)}>{item.Goal}</p>
                        </div>
                        {["In Active", "False"].includes(item.GoalStatus) &&
                          <p className='text Partialdenied-clr fst-italic text-nowrap'>InActive</p>}
                      </div>
                    )
                  })}
                </div>
                <ShowHideInActive />
              </> :
              <></>)}
        </div>
      </div>
    </>
  )
}

export default Goals